import React from 'react';
import ScrollContent from "components/UI/ScrollContent";
import MenuSkeleton from "./skeleton/MenuSkeleton";
import styles from "./Menu.module.css";

function Menu(props) {
    const {loading, menus} = props;

    if(!menus || loading) {
        return <MenuSkeleton/>;
    }
    return(
        <div className={styles.wrapper}>
            <ScrollContent mr={36}>
                <div className={styles.list_menu}>
                    {menus.map((menu, index)=> {
                        return(
                            <div className={styles.menu} key={index}>
                                <h4 className={styles.item_title}>{menu.name}</h4>
                                <div dangerouslySetInnerHTML={{ __html: menu.menu }} />    
                            </div>
                        );
                    })}
                </div>
            </ScrollContent>
        </div>
    );

}
export default Menu;